export default __webpack_public_path__ + "static/media/google-setup-1-en.e20c5e74.jpeg";